var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.152 5.77v2.304h-2.304V5.77h2.304Zm-2.304 7.38h2.304v-2.304h-2.304v2.304Zm0 5.076h2.304v-2.304h-2.304v2.304Z",
    fill: "#000"
  })));
};
export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy4xNTIgNS43NzAwMlY4LjA3NDAySDEwLjg0OFY1Ljc3MDAySDEzLjE1MlpNMTAuODQ4IDEzLjE1SDEzLjE1MlYxMC44NDZIMTAuODQ4VjEzLjE1Wk0xMC44NDggMTguMjI2SDEzLjE1MlYxNS45MjJIMTAuODQ4VjE4LjIyNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";